import React, { useContext } from "react";
import PlatformContext from "./PlatformContext.jsx";

export default function OsChrome() {
  const { platform, chromeHeight } = useContext(PlatformContext);

  const time = platform === "android" ? "8:05" : "8:05 AM";
  const date = platform === "android" ? "" : "Fri Mar 1, 2024";

  return (
    <div
      className={`
        ${platform === "android" ? "tw-bg-black tw-bg-opacity-50" : ""}
        tw-fixed
        tw-left-0
        tw-top-0
        tw-z-10
        tw-flex
        tw-h-[var(--height)]
        tw-w-full
        tw-items-center
        tw-px-5
        tw-py-3
        tw-text-sm
        tw-text-white
      `}
      style={{ "--height": `${chromeHeight}px` } as React.CSSProperties}
    >
      <time>
        {time} <span className='max-sm:tw-hidden tw-ml-3'>{date}</span>
      </time>
    </div>
  );
}
